


























































































































































































































































































import axios from 'axios';
import i18n from 'vue-i18n';
import { sub, isAfter } from 'date-fns';
import EventBus from '@/eventBus';
import { google, outlook, office365, yahoo, ics } from 'calendar-link';
import { get, groupBy } from 'lodash';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoBookingModal from '@/components/Organisms/co-booking-modal/CoBookingModal.vue';
import CoPrice from '@/components/Atoms/co-price/coPrice.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoTableColumnSelector from '@/components/Molecules/co-table-column-selector/CoTableColumnSelector.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import { BookingGranularityType, CheckOutDayType } from '@/components/Organisms/co-booking-resource/models.ts';

const DEFAULT_BOOKING_COLUMN_KEYS = [
    'CreatedAt',
    'Start',
    'End',
    'Duration',
    'User.Profile.Name',
    'Title',
    'Resource',
    'Status',
    'Price.PriceInCentsGross',
    'Actions',
];

const MEMBER_BOOKINGS_HISTORY_TABLE_PREFERENCE_KEY = 'memberBookingsHistoryTable';
const MEMBERS_BOOKING_HISTORY_SELECTED_COLUMNS_PREFERENCE_KEY = 'selectedFieldKeys';

export default {
    components: {
        CoRoundButton,
        CoText,
        CoIcon,
        CoHeadline,
        CoCard,
        CoButton,
        CoTable,
        CoBookingModal,
        CoPrice,
        CoSelect,
        CoTableColumnSelector,
        CoUser,
    },
    name: 'CoMyBookings',
    data() {
        return {
            loading: true,
            bookings: [],
            bookingshistory: [],
            next: [],

            googleCalendarLink: '',
            icsCalendarLink: '',
            outlookCalendarLink: '',

            bookingForView: null,

            bookingsBeingCancelled: {},
            user: null,
            selectedFieldKeys: DEFAULT_BOOKING_COLUMN_KEYS,
            // Expose the relevant booking payload fields in the selector while keeping the default view compact.
            columns: [
                {
                    title: this.$t('labels.id'),
                    key: 'ID',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.createdat'),
                    key: 'CreatedAt',
                    style: 'width: 7.5rem',
                },
                {
                    title: this.$t('labels.updatedat'),
                    key: 'UpdatedAt',
                    style: 'width: 7.5rem',
                },
                {
                    title: `${this.$t('labels.user')} ${this.$t('labels.id')}`,
                    key: 'UserID',
                    style: 'width: 10rem',
                },
                {
                    title: `${this.$t('labels.bookingBy')} ${this.$t('labels.id')}`,
                    key: 'CreatedByUserID',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.start'),
                    key: 'Start',
                    style: 'width: 9rem',
                },
                {
                    title: this.$t('labels.end'),
                    key: 'End',
                    style: 'width: 9rem',
                },
                {
                    title: this.$t('labels.duration'),
                    key: 'Duration',
                    notSortable: true,
                    style: 'width: 5rem',
                },
                {
                    title: this.$t('labels.user'),
                    key: 'User.Profile.Name',
                    style: 'width: 10rem',
                    disabled: true,
                    alwaysSelected: true,
                },
                {
                    title: this.$t('labels.title'),
                    key: 'Title',
                    notSortable: true,
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.description'),
                    key: 'Description',
                    notSortable: true,
                    style: 'width: 14rem',
                },
                {
                    title: this.$t('labels.resource'),
                    key: 'Resource',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.resourceid'),
                    key: 'ResourceID',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.status'),
                    key: 'Status',
                    style: 'width: 4rem',
                },
                {
                    title: this.$t('labels.currency'),
                    key: 'Currency',
                    style: 'width: 6rem',
                },
                {
                    title: this.$t('labels.pricedisplay'),
                    key: 'Price.PriceInCents',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.pricenet'),
                    key: 'Price.PriceInCentsNet',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.pricegross'),
                    key: 'Price.PriceInCentsGross',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.billingcyclestart'),
                    key: 'Price.BillingCycleStart',
                    style: 'width: 9rem',
                },
                {
                    title: this.$t('labels.billingcycleend'),
                    key: 'Price.BillingCycleEnd',
                    style: 'width: 9rem',
                },
                {
                    title: `${this.$t('labels.price')} ${this.$t('labels.details')}`,
                    key: 'PriceItemsDetails',
                    notSortable: true,
                    style: 'width: 20rem',
                },
                {
                    title: this.$t('labels.usedcashcredits'),
                    key: 'UsedCashCredits',
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.usedtimecredits'),
                    key: 'UsedTimeCredits',
                    style: 'width: 8rem',
                },
                {
                    title: this.$t('labels.refunded'),
                    key: 'Refunded',
                    style: 'width: 6rem',
                },
                {
                    title: this.$t('labels.refundedat'),
                    key: 'RefundedAt',
                    style: 'width: 9rem',
                },
                {
                    title: this.$t('labels.coupons'),
                    key: 'Coupons',
                    notSortable: true,
                    style: 'width: 10rem',
                },
                {
                    title: this.$t('labels.upgrades'),
                    key: 'Upgrades',
                    notSortable: true,
                    style: 'width: 12rem',
                },
                {
                    title: this.$t('labels.block'),
                    key: 'Block',
                    style: 'width: 6rem',
                },
                {
                    title: this.$t('labels.numberofblockingslots'),
                    key: 'NumberOfBlockingSlots',
                    style: 'width: 8rem',
                },
                {
                    title: this.$t('labels.checkouturl'),
                    key: 'CheckoutURL',
                    notSortable: true,
                    style: 'width: 14rem',
                },
                {
                    title: this.$t('labels.bookedasadmin'),
                    key: 'BookedAsAdmin',
                    style: 'width: 7rem',
                },
                {
                    title: this.$t('labels.priceoverride'),
                    key: 'PriceOverride',
                    style: 'width: 7rem',
                },
                {
                    title: this.$t('labels.actions'),
                    key: 'Actions',
                    notSortable: true,
                    style: 'width: 2.25rem',
                    class: 'text-right',
                },
            ],
            currency: this.$store?.state?.space?.Currency,
            // utility for grouping by billing cycle
            bookingsByBillingCycle: null,
            grouped: { Value: true },
            // utility for listing bookings for child users
            parentID: null,
            userProfiles: null,
            parentMembership: null,
            nextLoading: false,
        };
    },
    computed: {
        defaultSelectedFieldKeys() {
            return DEFAULT_BOOKING_COLUMN_KEYS;
        },
        // Keep the rendered booking columns aligned with the selector state owned by this page.
        selectedColumns() {
            return this.columns.filter((column) => this.selectedFieldKeys.includes(column.key));
        },
        userTimeZone() {
            try {
                return Intl.DateTimeFormat().resolvedOptions().timeZone;
            } catch (e) {
                return null;
            }
        },
    },
    created() {
        const { ID } = this.$route.params;
        this.parentID = ID;
        this.initializeSelectedFieldsPreference();
        // initiate fetch of user profile and bookings history
        this.getMembershipInfoAndProfiles(ID);
    },
    watch: {
        grouped(newVal) {
            // process bookings when display mode changes
            this.sortBookings();
        },
    },
    methods: {
        get,
        formatBookingDuration(item) {
            const durationInSeconds = Math.max(0, (Number(item?.End) || 0) - (Number(item?.Start) || 0));

            if (get(item, 'Resource.BookingGranularity') === BookingGranularityType.BookingGranularityDay) {
                // Mirror backend billing by counting calendar-day units in the rendered timezone.
                const timeZone = this.userTimeZone || 'UTC';
                const millisecondsPerDay = 24 * 60 * 60 * 1000;
                const calendarDayFormatter = new Intl.DateTimeFormat('en-US', {
                    timeZone,
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
                const getCalendarDayIndex = (timestampInSeconds) => {
                    const dateParts = calendarDayFormatter.formatToParts(new Date(timestampInSeconds * 1000));
                    const year = Number(dateParts.find((part) => part.type === 'year')?.value || 0);
                    const month = Number(dateParts.find((part) => part.type === 'month')?.value || 1);
                    const day = Number(dateParts.find((part) => part.type === 'day')?.value || 1);

                    return Math.floor(Date.UTC(year, month - 1, day) / millisecondsPerDay);
                };
                const startDayIndex = getCalendarDayIndex(Number(item?.Start) || 0);
                const endDayIndex = getCalendarDayIndex(Number(item?.End) || 0);
                const dayDiff = Math.max(0, endDayIndex - startDayIndex);
                const isSameDayCheckout =
                    get(item, 'Resource.DayBooking.CheckOutDay') === CheckOutDayType.CheckOutDaySameDay;
                const dayCount = isSameDayCheckout ? dayDiff + 1 : dayDiff === 0 ? 1 : dayDiff;

                return `${dayCount} ${this.$tc('labels.day', dayCount)}`;
            }

            const hourCount = Math.round(durationInSeconds / 60 / 60);
            return `${Number(durationInSeconds / 60 / 60).toFixed(1)} ${this.$tc('labels.hour', hourCount)}`;
        },
        adminGetUserByID(ID) {
            return new Promise((resolve, reject) => {
                if (this.userProfiles && this.userProfiles[ID]) {
                    resolve(true);
                    return;
                }
                this.$store
                    .dispatch('adminGetUserByID', ID)
                    .then((response) => {
                        this.userProfiles = {
                            ...this.userProfiles,
                            [ID]: response || {},
                        };
                        resolve(true);
                    })
                    .catch((error) => {
                        const message = {
                            Message: this.$t('errors.usernotfound'),
                            Details: error.response.data,
                        };
                        EventBus.$emit('ERROR', message);
                        this.$router.push(`/admin/community/member/list`);
                        resolve(true);
                    });
            });
        },
        clickedRow(index, item) {
            this.handleEventClick(item);
        },
        sortBookings(input = this.bookings) {
            let tempList: any = [];
            input.forEach((element) => {
                const start = new Date(get(element, 'Start', 0) * 1000);
                const now = new Date();

                const cancelPeriod = start;
                const diff = sub(cancelPeriod, {
                    hours: get(element, 'Resource.CancellationPeriod', 0),
                });
                let canCancel = true;
                if (isAfter(now, diff) || element?.Status === 'cancelled') {
                    canCancel = false;
                }
                element.canCancel = canCancel;

                tempList.push(element);
            });

            if (this.grouped.Value === false) {
                this.bookingshistory = [{ items: tempList }];
                return;
            }
            // group by billing cycle
            tempList = groupBy(tempList, (bkng) =>
                bkng?.Price?.BillingCycleStart
                    ? `${bkng?.Price?.BillingCycleStart || ''}-${bkng?.Price?.BillingCycleEnd || ''}`
                    : 'none'
            );
            const groupOrder = Object.keys(tempList).sort().reverse();
            const groupedItems = [];
            groupOrder.forEach((key) => {
                // skip 'none'
                if (key === 'none') return;
                groupedItems.push({
                    key,
                    items: tempList[key].sort((a, b) => get(b, 'Start', 0) - get(a, 'Start', 0)), // sort by start date desc
                });
            });
            // finally add 'none' to the end of the list
            if (tempList.none) {
                groupedItems.push({
                    key: 'none',
                    items: tempList.none.sort((a, b) => get(b, 'Start', 0) - get(a, 'Start', 0)), // sort by start date desc
                });
            }
            this.bookingshistory = groupedItems;
        },
        getMyBookingsHistory(id, next = null) {
            return new Promise((resolve) => {
                let url = `/admin/booking/history?userid=${id}&sortby=start&limit=100`;
                if (next) {
                    url = next;
                }
                axios({
                    method: 'GET',
                    url,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        response?.data?.Next ? this.next.push(response.data.Next) : null;
                        const bookings = (response?.data?.Bookings || [])
                            .filter((item) => !item.Block)
                            .map((bkng) => ({
                                ...bkng,
                                User: this.userProfiles?.[bkng.UserID] || null,
                                // Store a plain-text export value so the table cell and CSV export stay aligned.
                                PriceItemsDetails: this.formatBookingPriceItemDetails(bkng),
                            }));

                        if (bookings.length === 0) {
                            resolve(true);
                            return;
                        }
                        // append new bookings to existing list
                        this.bookings = this.bookings.concat(bookings);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        resolve(true);
                    });
            });
        },
        bookingModalClosed() {
            this.bookingForView = null;
        },
        bookingCancelFailed(error) {
            EventBus.$emit('ERROR', {
                Message: this.$t('errors.failedGeneric'),
                Details: get(error, 'response.data', ''),
            });
        },
        bookingCanceled() {
            this.bookings = this.bookings.filter((item) => item?.ID !== this.bookingForView?.ID);
            this.bookingForView = null;
            EventBus.$emit('INFO', {
                Message: this.$t('messages.booking.cancelSuccess'),
            });
        },
        handleEventClick(bkng) {
            this.bookingForView = bkng;
        },
        getBookingPriceItemNameMap(booking) {
            const idToNames = {};

            if (booking?.Resource) {
                idToNames[booking.Resource.ID] = booking.Resource.Name;
            }

            (get(booking, 'Upgrades', []) || []).forEach((upgrade) => {
                idToNames[upgrade.OriginalID] = upgrade.Name;
            });

            return idToNames;
        },
        getBookingPriceItemDetails(booking) {
            const priceItems = get(booking, 'Price.Items', []);
            if (!Array.isArray(priceItems) || priceItems.length === 0) {
                return [];
            }

            const idToNames = this.getBookingPriceItemNameMap(booking);

            // Flatten the nested booking price items into table-friendly lines.
            return priceItems.reduce((items, priceItem) => {
                const taxPercentage = priceItem.TaxPercentage || 0;
                let tax = `${taxPercentage}%`;
                if (priceItem.TaxRateName) {
                    tax += ` ${priceItem.TaxRateName}`;
                }

                items.push({
                    name: idToNames[priceItem.ResourceID] || priceItem.ResourceID || '-',
                    quantity: priceItem.Quantity || 1,
                    tax,
                    displayprice: priceItem.PriceInCentsBeforeCredits || 0,
                    net: priceItem.PriceInCentsBeforeCreditsNet || 0,
                    gross: priceItem.PriceInCentsBeforeCreditsGross || 0,
                });

                if (priceItem.CreditsInCents) {
                    items.push({
                        name: `↳${this.$t('labels.credits')}`,
                        quantity: '',
                        tax: '',
                        displayprice: -(priceItem.CreditsInCents || 0),
                        net: -(priceItem.CreditsInCentsNet || 0),
                        gross: -(priceItem.CreditsInCentsGross || 0),
                    });
                }

                if (priceItem.DiscountInCents) {
                    items.push({
                        name: `↳${this.$t('labels.couponcode')} "${priceItem.PromoCodeName || ''}"`,
                        quantity: '',
                        tax: '',
                        displayprice: -(priceItem.DiscountInCents || 0),
                        net: -(priceItem.DiscountInCentsNet || 0),
                        gross: -(priceItem.DiscountInCentsGross || 0),
                    });
                }

                return items;
            }, []);
        },
        formatBookingPriceItemDetails(booking) {
            const priceItems = this.getBookingPriceItemDetails(booking);
            if (priceItems.length === 0) {
                return '';
            }

            const header = ['name', 'quantity', 'tax', 'display', 'net', 'gross'].join(',');
            const lines = priceItems.map((priceItem) =>
                [
                    priceItem.name,
                    priceItem.quantity || '',
                    priceItem.tax || '',
                    priceItem.displayprice || 0,
                    priceItem.net || 0,
                    priceItem.gross || 0,
                ]
                    .map((value) => `"${String(value).replace(/"/g, '""')}"`)
                    .join(',')
            );

            return [header, ...lines].join('\n');
        },
        convertToPlain(html) {
            const tempDivElement = document.createElement('div');
            tempDivElement.innerHTML = html;
            return tempDivElement.textContent || tempDivElement.innerText || '';
        },
        makeCalendarLink(booking, type) {
            this.calendarEvent = {
                title: booking.Title,
                description: this.convertToPlain(booking.Resource.Name),
                start: new Date(booking.Start * 1000).toISOString(),
                end: new Date(booking.End * 1000).toISOString(),
            };

            // Then fetch the link
            if (type === 'google') {
                this.googleCalendarLink = google(this.calendarEvent);
                window.location.href = this.googleCalendarLink;
            } else if (type === 'outlook') {
                this.outlookCalendarLink = outlook(this.calendarEvent);
                window.location.href = this.outlookCalendarLink;
            } else if (type === 'ics') {
                this.icsCalendarLink = ics(this.calendarEvent);
                window.location.href = this.icsCalendarLink;
            }
        },
        async getMembershipInfoAndProfiles(id) {
            // fetch membership details to get child user IDs
            let parentMembership = null;
            try {
                parentMembership = await axios.get(`/admin/community/member/membership/${id}`);
            } catch (error) {
                console.log(error);
            }
            // add parent user ID to the list
            let memberUserIDs = [id];
            if (this.$unleash?.isEnabled('frontend.bookingHistoryShowChildusers')) {
                // if feature flag is enabled, also add child user IDs to the list
                memberUserIDs = memberUserIDs.concat(parentMembership?.data?.childPlans?.map((m) => m.userID) || []);
            }
            // fetch user profiles by user ID
            try {
                await Promise.all(memberUserIDs.map((memberID) => this.adminGetUserByID(memberID)));
            } catch (error) {
                console.log(error);
            }
            // fetch bookings for child user IDs
            try {
                await Promise.all(memberUserIDs.map((memberID) => this.getMyBookingsHistory(memberID)));
            } catch (error) {
                console.log(error);
            }
            // assign parent user info
            this.user = this.userProfiles[id] || null;
            // finally sort and group bookings for display
            this.sortBookings();
            this.loading = false;
        },
        async fetchNextBookings() {
            if (this.next.length === 0) return;
            // make copy of next links array and clear original to prevent multiple fetches of the same link
            const nextLinks = [...this.next];
            this.next = [];
            // fetch next bookings for all next links in the queue
            try {
                this.nextLoading = true;
                await Promise.all(nextLinks.map((link) => this.getMyBookingsHistory(null, link)));
                this.sortBookings();
            } catch (error) {
                // restore next links to the queue if fetch fails to allow retrying
                this.next = [...nextLinks];
                console.log(error);
            }
            this.nextLoading = false;
        },
        updateSelectedFields(selectedFieldKeys) {
            this.selectedFieldKeys = selectedFieldKeys;
            this.$store.dispatch('setTablePreference', {
                tableKey: MEMBER_BOOKINGS_HISTORY_TABLE_PREFERENCE_KEY,
                preferenceKey: MEMBERS_BOOKING_HISTORY_SELECTED_COLUMNS_PREFERENCE_KEY,
                value: selectedFieldKeys,
            });
        },
        initializeSelectedFieldsPreference() {
            return this.$store
                .dispatch('getTablePreference', {
                    tableKey: MEMBER_BOOKINGS_HISTORY_TABLE_PREFERENCE_KEY,
                    preferenceKey: MEMBERS_BOOKING_HISTORY_SELECTED_COLUMNS_PREFERENCE_KEY,
                    fallback: DEFAULT_BOOKING_COLUMN_KEYS,
                })
                .then((persistedSelectedFieldKeys: string[]) => {
                    if (Array.isArray(persistedSelectedFieldKeys) && persistedSelectedFieldKeys.length > 0) {
                        // Restore the table-specific column selection so other tables can persist their own preferences too.
                        this.selectedFieldKeys = persistedSelectedFieldKeys;
                    }
                });
        },
    },
};
